module.exports = __webpack_public_path__ + "img/115ne.6f99544b.svg";